import { DropTargetMonitor } from 'react-dnd';

export const isOverLeft = (
  divRef: HTMLDivElement | null,
  monitor: DropTargetMonitor
): boolean => {
  const hoverBoundingRect = divRef?.getBoundingClientRect();

  if (hoverBoundingRect) {
    const width = hoverBoundingRect.right - hoverBoundingRect.left;
    const hoverMiddleX = width / 2;
    const initialClientSourceOffset = monitor.getInitialSourceClientOffset();
    const differenceFromInitialSource = monitor.getDifferenceFromInitialOffset();

    if (initialClientSourceOffset && differenceFromInitialSource) {
      // Gives info if user draged source LEFT (positive number), or DOWN (negative number)
      const hoverOffsetX = initialClientSourceOffset.x - hoverBoundingRect.left;

      const hoverPositionInCol =
        (width + differenceFromInitialSource.x + hoverOffsetX) / 2;

      if (hoverPositionInCol < hoverMiddleX) {
        return true;
      }
    }
  }

  return false;
};
